import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'

// Resuelve (o crea) la fila Usuario del que llama, cruzando por oid/email del token —
// no requiere ningún parámetro, el backend lo resuelve del propio JWT.
export const usuarioActualApi = createApi({
  reducerPath: 'usuarioActualApi',
  baseQuery,
  endpoints: (builder) => ({
    getUsuarioActual: builder.query<void, void>({
      query: () => ({
        url: `/UsuarioActualBusiness`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetUsuarioActualQuery } = usuarioActualApi
